import React from 'react';
import { FaUserFriends, FaBuilding, FaHandshake, FaBullhorn, FaTasks } from 'react-icons/fa';
import ProcessamentoCard from '../components/ProcessamentoCard';
import './Dashboard.css';

// --- Mock Data ---
const kpiData = [
  { title: 'Total de Clientes', value: '1,284', icon: <FaUserFriends />, color: '#3498db' },
  { title: 'Total de Imóveis', value: '3,490', icon: <FaBuilding />, color: '#2ecc71' },
  { title: 'Imóveis Captados (30d)', value: '78', icon: <FaHandshake />, color: '#e67e22' },
  { title: 'Campanhas Ativas', value: '12', icon: <FaBullhorn />, color: '#9b59b6' },
];

const recentActivities = [
  { icon: <FaUserFriends />, text: 'Novo cliente "Carlos Silva" adicionado.', meta: 'Há 2 horas por @admin' },
  { icon: <FaBuilding />, text: 'Novo imóvel (ID: 987) captado em "Centro".', meta: 'Há 5 horas por @corretor1' },
  { icon: <FaBullhorn />, text: 'Campanha "Verão 2024" foi concluída.', meta: 'Ontem por @marketing' },
  { icon: <FaUserFriends />, text: 'Cliente "Ana Pereira" atualizou suas preferências.', meta: 'Ontem por @corretor2' },
];

const ongoingProcessos = [
  { id: 9901, tipo_processamento: 'IMPORTACAO_IMOVEIS', status: 'EM_PROCESSAMENTO', usuario_cadastro: 'admin', created_at: new Date(Date.now() - 2 * 60 * 60 * 1000).toISOString(), data_fim: null },
  { id: 9902, tipo_processamento: 'ATUALIZACAO_CLIENTES', status: 'EM_PROCESSAMENTO', usuario_cadastro: 'sistema', created_at: new Date(Date.now() - 30 * 60 * 1000).toISOString(), data_fim: null },
];

const Dashboard = () => {

  return (
    <div className="dashboard-container">
      <div className="dashboard-header">
        <h1>Dashboard</h1>
        <p>Bem-vindo de volta! Aqui está um resumo da sua atividade.</p>
      </div>

      {/* KPI Section */}
      <div className="kpi-grid">
        {kpiData.map((kpi, index) => (
          <div className="kpi-card" key={index}>
            <div className="icon" style={{ color: kpi.color }}>{kpi.icon}</div>
            <div className="info">
              <h3>{kpi.value}</h3>
              <p>{kpi.title}</p>
            </div>
          </div>
        ))}
      </div>

      <div className="dashboard-columns">
        {/* Recent Activity Section */}
        <div className="dashboard-section">
          <h2><FaTasks /> Atividade Recente</h2>
          <ul className="activity-list">
            {recentActivities.map((activity, index) => (
              <li className="activity-item" key={index}>
                <div className="icon">{activity.icon}</div>
                <div className="details">
                  <p>{activity.text}</p>
                  <span className="meta">{activity.meta}</span>
                </div>
              </li>
            ))}
          </ul>
        </div>

        {/* Ongoing Processes Section */}
        {ongoingProcessos.length > 0 && (
          <div className="dashboard-section">
            <h2>Processamentos em Andamento</h2>
            <div className="processamentos-grid">
              {ongoingProcessos.map(proc => (
                <ProcessamentoCard key={proc.id} processo={proc} />
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Dashboard;
